import getSiteFailedTnx from "../../ajax/actions/failed-site-transactions/siteFailed-get";
import { toggleURLQuery } from "../../helpers/UrlHelper";
import store from "../../Store";

export function toggleSiteFailedFilter(e, history, id) {
  return function (dispatch) {
    let { name, value } = e.target;

    toggleURLQuery(name, value, history);

    dispatch({
      type: "TOGGLE-SITE-FAILED-FILTER",
      name,
      value,
      history,
    });

    store.dispatch(getSiteFailedTnx(id));
  };
}

export function setOrganizationFailedID(id) {
  return function (dispatch) {
    dispatch({ type: "SET-ORGANIZATION-FAILED-ID", id });
  };
}

export function toggleSiteFailedModal() {
  return function (dispatch) {
    dispatch({ type: "TOGGLE-SITE-FAILED-MODAL" });
  };
}

export function toggleSiteFailedStatusModal() {
  return function (dispatch) {
    dispatch({ type: "TOGGLE-SITE-FAILED-STATUS-MODAL" });
  };
}
